import type { TSelector } from "../../../i18n/types";
import { type ProductReportRow } from "./useProductReportColumns";
import { type ProductReportGrouping } from "../../../zodios/common/productReportGroupingSchema";

type LabeledOption<V> = { label: TSelector; value: V };

export const PRODUCT_REPORT_GROUPING_OPTIONS: ReadonlyArray<LabeledOption<ProductReportGrouping>> = [
  { label: ($) => $.perf_reports["By Product"], value: "product_id" },
  { label: ($) => $.perf_reports["By ASIN"], value: "asin" },
  { label: ($) => $.perf_reports["By Parent ASIN"], value: "parent_asin_defaulted" },
] as const;

export const getRowIdForGrouping = (row: ProductReportRow, grouping: ProductReportGrouping): string => {
  switch (grouping) {
    case "product_id":
      return row.product_id!.toString();
    case "asin":
      return row.asin!;
    case "parent_asin_defaulted":
      return row.parent_asin_defaulted!;
  }
};
